import { API } from "aws-amplify";
import { getApplication } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_APPLICATION: APITypes.Application = {
  id: "",
  startDate: "",
  endDate: "",
  status: APITypes.ApplicationStatusType.Submitted,
  __typename: "Application",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getApplicationDetails = async (applicationID: String) => {
  try {
    const response = (await API.graphql({
      query: getApplication,
      variables: {
        id: applicationID,
      },
    })) as { data?: APITypes.GetApplicationQuery };

    return {
      success: true,
      data: response.data?.getApplication || EMPTY_APPLICATION,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_APPLICATION,
      error,
    };
  }
};
